/* Elements Supply — Catalog Pro theme runtime */
(function () {
  'use strict';
  var ES = window.ES || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  // Swap a responsive <img>'s source. srcset/sizes take precedence over src,
  // so drop them or the browser keeps showing the original image.
  function setImgSrc(img, src) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
  }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }
  ES.formatMoney = formatMoney;

  /* =====================================================================
     Wholesale All-in-One — live volume-discount rules (namespace "wsaiovd")
     Read once from the JSON the theme prints (snippets/wholesale-data.liquid).
     Editing a rule in the app updates these metafields, so the storefront
     reflects the change on next page load with no theme edit.
     ===================================================================== */
  var ES_WS_RULES = null;
  function wsRules() {
    if (ES_WS_RULES) return ES_WS_RULES;
    ES_WS_RULES = [];
    var node = $('[data-ws-rules]');
    if (node) {
      try {
        var arr = JSON.parse(node.textContent);
        if (Array.isArray(arr)) ES_WS_RULES = arr;
      } catch (e) { ES_WS_RULES = []; }
    }
    return ES_WS_RULES;
  }

  function wsScheduleActive(rule) {
    if (!rule.schedule_active) return true;
    var s = rule.schedule || {};
    var now = Date.now();
    if (s.start_date) { var st = Date.parse(s.start_date); if (!isNaN(st) && now < st) return false; }
    if (s.end_date) { var en = Date.parse(s.end_date); if (!isNaN(en) && now > en) return false; }
    return true;
  }

  function wsExcluded(rule, pid, cols) {
    var ep = rule.exclude_products || [];
    for (var i = 0; i < ep.length; i++) { if (String(ep[i].id) === String(pid)) return true; }
    var ec = rule.exclude_collections || [];
    for (var j = 0; j < ec.length; j++) { if (cols.indexOf(ec[j].handle) !== -1) return true; }
    return false;
  }

  // Find the volume-discount rule that applies to a product, mirroring the app's
  // precedence: specific product > collection > entire store. Returns the rule
  // or null. Only published, "all customers" rules within schedule are eligible.
  function wsFindRule(pid, cols) {
    var rules = wsRules().filter(function (r) {
      return r && r.state === 'published'
        && (r.customer_group === 'all' || !r.customer_group)
        && wsScheduleActive(r);
    });
    function match(kind) {
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        if (r.applies_to !== kind) continue;
        if (wsExcluded(r, pid, cols)) continue;
        if (kind === 'products') {
          var ps = r.products || [];
          for (var a = 0; a < ps.length; a++) { if (String(ps[a].id) === String(pid)) return r; }
        } else if (kind === 'collections') {
          var cs = r.collections || [];
          for (var b = 0; b < cs.length; b++) { if (cols.indexOf(cs[b].handle) !== -1) return r; }
        } else if (kind === 'entire_store') {
          return r;
        }
      }
      return null;
    }
    return match('products') || match('collections') || match('entire_store');
  }

  // Resolve a product's volume tiers as [{min, pct}], ascending. [] = no discount.
  function wsTiers(pid, cols) {
    var rule = wsFindRule(pid, cols);
    if (!rule || !rule.volume_discount) return [];
    return rule.volume_discount.map(function (v) {
      return { min: parseInt(v.qty, 10) || 0, pct: parseFloat(v.value) || 0 };
    }).filter(function (t) { return t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
  }
  ES.wsTiers = wsTiers;

  function colsFrom(el) {
    var raw = (el && el.getAttribute('data-ws-cols')) || '';
    return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  // Find the active tier index for a quantity within a parsed-tier array.
  function activeTier(tiers, qty) {
    var idx = 0;
    for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i].min) idx = i; }
    return idx;
  }

  // Set by bindPDP so the global reconciler can recompute the tiered price +
  // total from the live quantity — even when the quantity was changed by the
  // Wholesale All-in-One app's own break table (which sets the native qty field
  // without firing the events our inline break table dispatches).
  var esPdpRecompute = null;

  // "You are ordering N" = per-unit count (on the element) × quantity. Reads the
  // multiplier straight off each [data-ordering] element so it never depends on
  // the variant-data lookup.
  function setOrdering(scope, qty) {
    $all('[data-ordering]', scope || document).forEach(function (o) {
      var per = parseInt(o.getAttribute('data-per-unit'), 10);
      if (isNaN(per)) per = 0;
      o.textContent = (per > 0 ? per * qty : qty).toLocaleString('en-US');
    });
  }

  /* ===================== Mega menus ===================== */
  // Reflect real open-state (drawer or any mega) onto the body so the mobile
  // PDP sticky bar can hide itself. Recomputed from the DOM so overlapping
  // click handlers (e.g. burger click bubbling to the document closer) can't
  // leave a stale class.
  function syncMenuOpen() {
    var open = !!document.querySelector('[data-drawer].is-open, [data-mega].is-open');
    document.body.classList.toggle('es-menu-open', open);
  }
  function closeMegas(except) {
    $all('[data-mega]').forEach(function (m) {
      if (m !== except) m.classList.remove('is-open');
    });
    $all('[data-mega-toggle]').forEach(function (b) {
      if (!except || b.getAttribute('data-mega-toggle') !== except.getAttribute('data-mega')) {
        b.setAttribute('aria-expanded', 'false');
      }
    });
    syncMenuOpen();
  }
  $all('[data-mega-toggle]').forEach(function (btn) {
    on(btn, 'click', function (e) {
      e.stopPropagation();
      var key = btn.getAttribute('data-mega-toggle');
      var panel = $('[data-mega="' + key + '"]');
      var open = panel && panel.classList.contains('is-open');
      closeMegas();
      if (panel && !open) {
        panel.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
      syncMenuOpen();
    });
  });
  on(document, 'click', function (e) {
    if (!e.target.closest('.es-nav')) closeMegas();
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') { closeMegas(); closeDrawer(); closeCart(); } });

  /* ===================== Mobile drawer ===================== */
  function openDrawer() { var d = $('[data-drawer]'); if (d) { d.classList.add('is-open'); syncMenuOpen(); } }
  function closeDrawer() { var d = $('[data-drawer]'); if (d) { d.classList.remove('is-open'); syncMenuOpen(); } }
  $all('[data-drawer-open]').forEach(function (b) { on(b, 'click', openDrawer); });
  $all('[data-drawer-close]').forEach(function (b) { on(b, 'click', closeDrawer); });
  // drawer accordion (expand a category to reveal its sub-items)
  $all('[data-acc-toggle]').forEach(function (btn) {
    on(btn, 'click', function () {
      var panel = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
    });
  });

  /* ===================== Cart drawer ===================== */
  function openCart() { var d = $('[data-cart-drawer]'); if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; document.body.classList.add('es-cart-open'); } }
  function closeCart() { var d = $('[data-cart-drawer]'); if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; document.body.classList.remove('es-cart-open'); } }
  ES.openCart = openCart;
  // Cart open/close via ONE delegated listener bound a single time. Previously
  // bindCartUI() re-bound the header cart button on every cart update, stacking
  // duplicate handlers and leaving re-rendered buttons dependent on a re-bind —
  // which made the slide-cart button feel sluggish. Delegation is instant and
  // always covers current + future [data-cart-open]/[data-cart-close] elements.
  var _cartDelegated = false;
  function bindCartUI() {
    if (_cartDelegated) return;
    _cartDelegated = true;
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
    });
  }
  bindCartUI();

  function getSection(name, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-section="' + name + '"]') || doc.body;
  }

  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var cur = $('[data-cart-drawer]');
      var fresh = getSection('cart-drawer', sections['cart-drawer']);
      if (cur && fresh) { cur.innerHTML = fresh.innerHTML; }
    }
    refreshCartCount(sections);
    bindCartUI();
    bindStepperChanges();
    updateFreightBar();
  }

  function refreshCartCount(sections) {
    fetch(ES.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $all('[data-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
        $all('[data-cart-subtotal]').forEach(function (e) { e.textContent = formatMoney(cart.total_price); });
      });
  }
  ES.refreshCart = function () { refreshCartCount(); };

  // The free-freight bar must use the volume-DISCOUNTED subtotal. Shopify's
  // native cart.total_price doesn't include the Wholesale app discount (that's
  // applied at checkout), so recompute the subtotal here from the same tier
  // rules the rest of the theme uses, and update the message + progress bar.
  function updateFreightBar() {
    var box = $('[data-freight]');
    if (!box) return;
    var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 0;
    if (!threshold) return;
    var dataEl = $('[data-ws-cart]');
    var lines = [];
    if (dataEl) { try { lines = JSON.parse(dataEl.textContent || '[]'); } catch (e) { lines = []; } }
    var subtotal = 0;
    lines.forEach(function (l) {
      var cols = String(l.cols || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var tiers = wsTiers(String(l.pid), cols);
      var pct = tiers.length ? tiers[activeTier(tiers, l.qty)].pct : 0;
      var perUnit = Math.round(l.base * (100 - pct) / 100);
      subtotal += perUnit * l.qty;
    });
    var msg = box.querySelector('[data-freight-msg]');
    var bar = box.querySelector('[data-freight-bar]');
    var remaining = threshold - subtotal;
    if (msg) {
      msg.innerHTML = remaining > 0
        ? 'Add <b style="color:var(--es-green)">' + formatMoney(remaining) + '</b> for free freight.'
        : '<span style="color:var(--es-green);font-weight:700">🎉 You qualify for free freight!</span>';
    }
    if (bar) { bar.style.width = (subtotal >= threshold ? 100 : (subtotal * 100 / threshold)) + '%'; }
  }
  ES.updateFreightBar = updateFreightBar;

  /* ---------- add to cart ---------- */
  function addToCart(id, qty, openAfter) {
    return fetch(ES.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        applySections(data.sections);
        if (openAfter !== false) openCart();
        return data;
      });
  }
  ES.addToCart = addToCart;

  $all('[data-product-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      // Let "Buy now" / dynamic checkout buttons submit normally to Shopify checkout.
      var submitter = e.submitter || document.activeElement;
      if (submitter && (submitter.name === 'checkout' || submitter.classList.contains('shopify-payment-button__button'))) {
        return;
      }
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      // The quantity input is linked via the form= attribute but lives outside
      // the <form>, so form.querySelector misses it. form.elements (or a direct
      // lookup) includes form-associated controls, so the real qty is used.
      var q = form.elements['quantity'] || form.querySelector('[name="quantity"]') || document.querySelector('.es-pdp__qtyinput');
      addToCart(id, q ? parseInt(q.value, 10) || 1 : 1, true);
    });
  });

  /* quick add buttons (cards / table rows) */
  $all('[data-add]').forEach(function (btn) {
    on(btn, 'click', function (e) {
      e.preventDefault();
      // Stop the click from bubbling to any app-level (Wholesale All-in-One)
      // delegated handler, which otherwise re-adds the line at quantity 1.
      e.stopPropagation();
      var id = btn.getAttribute('data-add');
      var qty = 1;
      var holder = btn.closest('[data-line]') || btn.closest('[data-row]') || btn.closest('[data-row-panel]');
      if (holder) { var qi = holder.querySelector('[data-qty-input]'); if (qi) qty = parseInt(qi.value, 10) || 1; }
      addToCart(id, qty, true);
    });
  });

  /* ---------- cart line change ---------- */
  function changeLine(key, qty, container) {
    return fetch(ES.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: ['cart-drawer', 'main-cart'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        applySections(data.sections);
        if (data.sections && data.sections['main-cart']) {
          var cur = $('[data-section="main-cart"]');
          var fresh = getSection('main-cart', data.sections['main-cart']);
          if (cur && fresh) { cur.innerHTML = fresh.innerHTML; bindAll(); }
        }
        return data;
      });
  }
  ES.changeLine = changeLine;

  function bindStepperChanges() {
    $all('[data-line-key]').forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      row.querySelectorAll('[data-line-minus],[data-line-plus]').forEach(function (b) {
        on(b, 'click', function () {
          var input = row.querySelector('[data-qty-input]');
          var v = parseInt(input.value, 10) || 1;
          v += b.hasAttribute('data-line-plus') ? 1 : -1;
          if (v < 0) v = 0;
          changeLine(key, v, row);
        });
      });
      var rm = row.querySelector('[data-line-remove]');
      on(rm, 'click', function (e) { e.preventDefault(); changeLine(key, 0, row); });
    });
  }

  /* ===================== Generic qty steppers ===================== */
  function bindSteppers() {
    $all('[data-stepper]').forEach(function (st) {
      if (st._bound) return; st._bound = true;
      var input = st.querySelector('[data-qty-input]');
      st.querySelectorAll('[data-minus],[data-plus]').forEach(function (b) {
        on(b, 'click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.hasAttribute('data-plus') ? 1 : -1;
          if (v < 1) v = 1;
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  // Keep "You are ordering" correct even if the price-break recompute doesn't
  // run (e.g. when app blocks change the buy box). Bound independently to the
  // PDP quantity input and steppers.
  // Reconcile "You are ordering" = per-unit x current quantity. Re-reads the
  // live qty input and [data-ordering] elements each time, so it is immune to
  // however the qty changed (steppers, price-break clicks, typing) and to any
  // app re-render that resets the buy box afterward.
  function reconcileOrdering() {
    var pdp = $('[data-pdp]');
    if (!pdp) return;
    var qi = pdp.querySelector('[data-qty-input]') || document.querySelector('.es-pdp__qtyinput');
    if (!qi) return;
    // Preferred path: run the full PDP recompute so the tiered per-unit price,
    // the Add-to-cart total AND "You are ordering" all follow the live quantity
    // together — this is what keeps the mobile sticky bar in sync when the
    // Wholesale app's break table sets the quantity behind our back.
    if (esPdpRecompute) { esPdpRecompute(); return; }
    var qty = parseInt(qi.value, 10) || 1;
    $all('[data-ordering]').forEach(function (o) {
      var per = parseInt(o.getAttribute('data-per-unit'), 10) || 0;
      var want = (per > 0 ? per * qty : qty).toLocaleString('en-US');
      if (o.textContent !== want) o.textContent = want;
    });
  }
  // Cheap interval backstop: only do work when the live quantity actually
  // changed since last tick, so an idle PDP does no per-frame layout work.
  var esLastReconcileQty = null;
  function reconcileOrderingIfChanged() {
    var pdp = $('[data-pdp]');
    if (!pdp) return;
    var qi = pdp.querySelector('[data-qty-input]') || document.querySelector('.es-pdp__qtyinput');
    if (!qi) return;
    if (qi.value === esLastReconcileQty) return;
    esLastReconcileQty = qi.value;
    reconcileOrdering();
  }
  function bindOrdering() {
    if (!$('[data-pdp]')) return;
    reconcileOrdering();
    if (window.__esOrdWatch) return;
    window.__esOrdWatch = true;
    // Any interaction in the buy box or sticky bar -> reconcile now and again
    // shortly after (to win against an app re-render that resets the value).
    var hit = function (e) {
      if (!e.target.closest || !e.target.closest('[data-pdp],[data-pdp-stickybar]')) return;
      reconcileOrdering();
      setTimeout(reconcileOrdering, 60);
      setTimeout(reconcileOrdering, 300);
    };
    document.addEventListener('click', hit, true);
    document.addEventListener('input', hit, true);
    document.addEventListener('change', hit, true);
    // Backstop so it can never get stuck on a stale value (e.g. the app changed
    // the quantity with no event). Guarded so idle ticks cost nothing.
    setInterval(reconcileOrderingIfChanged, 500);
  }

  /* ===================== PDP price-break recompute ===================== */
  function bindPDP() {
    var pdp = $('[data-pdp]');
    if (!pdp) return;
    var qtyInput = pdp.querySelector('[data-qty-input]');
    if (!qtyInput) return;

    // Per-product volume tiers from the LIVE Wholesale All-in-One rules.
    var pid = pdp.getAttribute('data-ws-pid');
    var cols = colsFrom(pdp);
    var tiers = wsTiers(pid, cols);
    var breaksBox = pdp.querySelector('[data-price-breaks]');
    var unitWord = (breaksBox && breaksBox.getAttribute('data-unit')) || 'case';

    function selectedVariant() {
      var sel = pdp.querySelector('[data-variant-select]');
      var opt;
      if (sel) opt = sel.options[sel.selectedIndex];
      else opt = pdp.querySelector('[data-variant-data]');
      if (!opt) return null;
      return {
        id: opt.getAttribute('data-vid'),
        price: parseInt(opt.getAttribute('data-price'), 10),
        perCase: parseInt(opt.getAttribute('data-bags'), 10) || 0,
        unit: opt.getAttribute('data-unit') || 'case'
      };
    }

    // Build the volume price-break table for the selected variant's base price.
    // No "you save %" column — quantity and per-unit price only.
    function buildBreaks(base) {
      if (!breaksBox) return;
      var quote = breaksBox.getAttribute('data-quote') || '/pages/custom-quote';
      var sku = encodeURIComponent(breaksBox.getAttribute('data-sku') || '');
      if (!tiers.length) {
        breaksBox.innerHTML = '<div class="es-breaks-quote">Ordering in volume? <a class="es-link" href="' + quote + '?sku=' + sku + '">Request a quote &rarr;</a></div>';
        return;
      }
      var rows = '';
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        var price = Math.round(base * (100 - t.pct) / 100);
        // qty applied when the row is clicked: bottom of the range (e.g. click "5–9" -> 5)
        var to = t.min;
        var label = (i === tiers.length - 1) ? (t.min + '+') : (t.min + ' &ndash; ' + (tiers[i + 1].min - 1));
        rows += '<tr data-tier-row="' + i + '" data-tier-min="' + t.min + '" data-tier-to="' + to + '"><td>' + label + '</td><td class="es-tier-price">' + formatMoney(price) + '</td></tr>';
      }
      breaksBox.innerHTML =
        '<table class="es-breaks"><thead><tr><th>Quantity (' + unitWord + 's)</th><th>Price / ' + unitWord + '</th></tr></thead><tbody>' + rows + '</tbody></table>' +
        '<div class="es-breaks-quote">Need a bigger volume? <a class="es-link" href="' + quote + '?sku=' + sku + '">Get a custom quote &rarr;</a></div>';
    }

    function recompute() {
      var v = selectedVariant();
      if (!v) return;
      var qty = parseInt(qtyInput.value, 10) || 1;
      var idx = tiers.length ? activeTier(tiers, qty) : -1;
      var pct = idx >= 0 ? tiers[idx].pct : 0;
      var perCaseCents = Math.round(v.price * (100 - pct) / 100);
      var total = perCaseCents * qty;

      $all('[data-pc-price]', pdp).forEach(function (pc) { pc.textContent = formatMoney(perCaseCents); });
      // document scope: the "You are ordering" element can sit outside [data-pdp]
      setOrdering(document, qty);
      $all('[data-add-total]', pdp).forEach(function (at) { at.textContent = formatMoney(total); });
      var sQtySync = pdp.querySelector('[data-sticky-qty]');
      if (sQtySync && document.activeElement !== sQtySync) sQtySync.value = qty;

      // hidden form id
      var idField = pdp.querySelector('[name="id"]');
      if (idField && v.id) idField.value = v.id;

      // highlight active tier row in the break table
      if (breaksBox) {
        $all('[data-tier-row]', breaksBox).forEach(function (r) {
          r.classList.toggle('is-active', parseInt(r.getAttribute('data-tier-row'), 10) === idx);
        });
      }
    }

    // initial table render
    (function () { var iv = selectedVariant(); if (iv) buildBreaks(iv.price); })();

    // Set the quantity and fire the same 'input' event the +/- steppers use, so
    // EVERY listener runs — the price recompute AND the "You are ordering"
    // updater. (Calling recompute() directly skipped the ordering updater.)
    function setQty(val) {
      qtyInput.value = val;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // click a price-break row -> set quantity to the top of that range; price/total follow
    if (breaksBox) {
      on(breaksBox, 'click', function (e) {
        var row = e.target.closest('[data-tier-row]');
        if (!row) return;
        var to = parseInt(row.getAttribute('data-tier-to'), 10);
        if (to > 0) setQty(to);
      });
    }

    // swap the gallery hero (and active thumb / mobile slide) to a variant's image
    function swapVariantImage(src, imageId) {
      if (!src) return;
      var main = $('[data-gallery-main]');
      var mainImg = main && main.querySelector('img');
      setImgSrc(mainImg, src);
      if (imageId) {
        $all('[data-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-image-id') === imageId);
        });
        var track = $('[data-gallery-track]');
        var slide = track && track.querySelector('[data-image-id="' + imageId + '"]');
        if (track && slide) track.scrollLeft = slide.offsetLeft - track.offsetLeft;
      }
    }

    // Expose for the global reconciler so the sticky bar can be re-synced after
    // the Wholesale app (or anything else) changes the quantity without events.
    esPdpRecompute = recompute;

    on(qtyInput, 'change', recompute);
    on(qtyInput, 'input', recompute);

    // sticky mobile bar stepper drives the same quantity
    var sMinus = pdp.querySelector('[data-sticky-minus]');
    var sPlus = pdp.querySelector('[data-sticky-plus]');
    var sQty = pdp.querySelector('[data-sticky-qty]');
    on(sMinus, 'click', function () { setQty(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1)); });
    on(sPlus, 'click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    on(sQty, 'input', function () { setQty(parseInt(sQty.value, 10) || 1); });

    var sel = pdp.querySelector('[data-variant-select]');
    on(sel, 'change', function () {
      // update gallery + sku if data attrs present
      var opt = sel.options[sel.selectedIndex];
      var skuEl = pdp.querySelector('[data-sku]');
      if (skuEl && opt.getAttribute('data-sku')) skuEl.textContent = opt.getAttribute('data-sku');
      if (breaksBox && opt.getAttribute('data-sku')) breaksBox.setAttribute('data-sku', opt.getAttribute('data-sku'));
      swapVariantImage(opt.getAttribute('data-image'), opt.getAttribute('data-image-id'));
      var nv = selectedVariant();
      if (nv) buildBreaks(nv.price);
      recompute();
    });
    recompute();
  }

  /* ===================== Variant <select> on cards/rows ===================== */
  function bindCardVariants() {
    $all('[data-card-variant]').forEach(function (sel) {
      on(sel, 'change', function () {
        var opt = sel.options[sel.selectedIndex];
        var card = sel.closest('[data-line]') || sel.closest('[data-row]');
        if (!card) return;
        var price = card.querySelector('[data-price-out]');
        if (price && opt.getAttribute('data-price')) price.textContent = formatMoney(parseInt(opt.getAttribute('data-price'), 10));
        var add = card.querySelector('[data-add]');
        if (add && opt.getAttribute('data-vid')) add.setAttribute('data-add', opt.getAttribute('data-vid'));
      });
    });
  }

  /* ===================== Collection filter collapse (mobile) ===================== */
  function bindFilterToggle() {
    var btn = $('[data-filters-toggle]');
    var wrap = $('[data-filters]');
    if (!btn || !wrap) return;
    on(btn, 'click', function () {
      // only acts as a toggle on mobile (desktop body is always shown via CSS)
      var open = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ============ Stock table volume pricing (live Wholesale rules) ============ */
  // For each row, resolve the product's volume tiers and fill the "as low as"
  // price + the expanded break cells. No "save %" — quantity and price only.
  function bindStockWholesale() {
    var hasRules = wsRules().length > 0;
    $all('[data-ws-row]').forEach(function (row) {
      var pid = row.getAttribute('data-ws-pid');
      var base = parseInt(row.getAttribute('data-base'), 10) || 0;
      var unit = row.getAttribute('data-unit') || 'case';
      var tiers = hasRules ? wsTiers(pid, colsFrom(row)) : [];
      // Row price stays at the per-case (qty 1) price — no "As low as".
      var panel = row.nextElementSibling;
      var brow = panel && panel.querySelector('[data-breakrow]');
      var pan = panel && panel.querySelector('.es-stock__pan');
      if (!tiers.length) {
        // No volume break — CSS moves the Price/Case above the qty selector.
        if (pan) pan.classList.add('es-stock__pan--nobreak');
        return;
      }
      if (pan) pan.classList.remove('es-stock__pan--nobreak');
      if (!brow) return;
      // Same tier ranges as the product page: "5 – 9", "10 – 24", "25+".
      var html = '';
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        var p = Math.round(base * (100 - t.pct) / 100);
        // qty applied when this cell is clicked: bottom of the range (e.g. click "5–9" -> 5)
        var to = t.min;
        var label = (i === tiers.length - 1)
          ? (t.min + '+')
          : (t.min + '–' + (tiers[i + 1].min - 1));
        html += '<button type="button" class="es-breakcell' + (i === 0 ? ' is-active' : '') +
                '" data-tier-to="' + to + '" data-tier-price="' + p + '">' +
                '<div class="es-breakcell__qty">' + label + '</div>' +
                '<div class="es-breakcell__price">' + formatMoney(p) + '</div>' +
                '<div class="es-breakcell__per">/ ' + unit + '</div></button>';
      }
      brow.innerHTML = html;

      // Highlight the tier that matches the row's current quantity (typed or
      // stepped) and sync the per-unit price. Mirrors the product page.
      var pnl = brow.closest('[data-row-panel]');
      // Two steppers share one quantity: the collapsed-row stepper and the
      // expanded-panel stepper. Keep them (and every price display) in sync.
      var panelInput = pnl && pnl.querySelector('[data-qty-input]');
      var rowInput = row.querySelector('[data-qty-input]');
      var priceOut = row.querySelector('[data-price-out]'); // collapsed-row price
      var rowPriceBs = pnl ? $all('[data-row-price] b', pnl) : [];
      // "As low as <lowest tier price> / unit" — shown on mobile instead of the break cells.
      var maxPct = 0;
      for (var mp = 0; mp < tiers.length; mp++) { if (tiers[mp].pct > maxPct) maxPct = tiers[mp].pct; }
      var alEl = pnl && pnl.querySelector('[data-aslowas]');
      if (alEl) { alEl.textContent = maxPct > 0 ? ('As low as ' + formatMoney(Math.round(base * (100 - maxPct) / 100)) + ' / ' + unit) : ''; }
      function applyQty(qty) {
        if (!(qty >= 1)) qty = 1;
        var idx = activeTier(tiers, qty);
        var cells = $all('.es-breakcell', brow);
        cells.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
        var pr = cells[idx] ? parseInt(cells[idx].getAttribute('data-tier-price'), 10) : NaN;
        if (isNaN(pr)) pr = Math.round(base * (100 - (tiers[idx] ? tiers[idx].pct : 0)) / 100);
        var money = formatMoney(pr);
        rowPriceBs.forEach(function (b) { b.textContent = money; });   // expanded panel + mobile card
        if (priceOut) priceOut.textContent = money;                    // collapsed row
        // Mirror the quantity into the other stepper (no event -> no loop).
        if (rowInput && (parseInt(rowInput.value, 10) || 1) !== qty) rowInput.value = qty;
        if (panelInput && (parseInt(panelInput.value, 10) || 1) !== qty) panelInput.value = qty;
      }
      function onPanelQty() { applyQty(parseInt(panelInput.value, 10) || 1); }
      function onRowQty() { applyQty(parseInt(rowInput.value, 10) || 1); }
      if (panelInput && !panelInput._wsQty) {
        panelInput._wsQty = true;
        on(panelInput, 'change', onPanelQty);
        on(panelInput, 'input', onPanelQty);
      }
      if (rowInput && !rowInput._wsQty) {
        rowInput._wsQty = true;
        on(rowInput, 'change', onRowQty);
        on(rowInput, 'input', onRowQty);
      }

      // Click a tier -> set this row's quantity to the bottom of the range (like
      // the product page). The quantity change re-syncs via applyQty.
      if (!brow._wsClick) {
        brow._wsClick = true;
        brow.addEventListener('click', function (e) {
          var cell = e.target.closest('[data-tier-to]');
          if (!cell) return;
          var to = parseInt(cell.getAttribute('data-tier-to'), 10);
          if (to > 0) applyQty(to);
        });
      }

      // Set correct initial price for whichever quantity is present.
      applyQty(parseInt((rowInput || panelInput || {}).value, 10) || 1);
    });
  }

  /* ===================== Stock table expand ===================== */
  function bindStockTable() {
    $all('[data-row-toggle]').forEach(function (btn) {
      on(btn, 'click', function () {
        var row = btn.closest('[data-row]');
        var panel = row && row.nextElementSibling;
        if (panel && panel.hasAttribute('data-row-panel')) {
          var open = panel.style.display !== 'none';
          panel.style.display = open ? 'none' : 'block';
          row.classList.toggle('is-open', !open);
        }
      });
    });
    $all('[data-expand-all]').forEach(function (btn) {
      on(btn, 'click', function () {
        var table = btn.closest('[data-stock-table]');
        var panels = $all('[data-row-panel]', table);
        var anyClosed = panels.some(function (p) { return p.style.display === 'none'; });
        panels.forEach(function (p) {
          p.style.display = anyClosed ? 'block' : 'none';
          var row = p.previousElementSibling;
          if (row) row.classList.toggle('is-open', anyClosed);
        });
      });
    });
  }

  /* ===================== Predictive search ===================== */
  var ES_SEARCH_LIMIT = 6;
  function bindPredictiveSearch() {
    var wrap = $('[data-predictive]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-predictive-input]');
    var results = wrap.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var form = wrap.querySelector('form');
    var timer;
    var lastShown = [];
    var index = null;        // [{t,u,i,s:[sku,...]}]
    var indexLoading = false;

    function normalize(q) {
      return q.toLowerCase()
        .replace(/["'″′]/g, ' ')
        .replace(/-/g, ' ')
        .replace(/t\s*shirt/g, 'tshirt')      // t-shirt / t shirt / tshirt -> tshirt
        .replace(/\b(?:reclosable|zipper|zip\s*lock(?:ing)?|ziplock|zip)\b/g, 'ziplock')  // reclosable = zipper = zip = ziplock
        .replace(/(\d)\s*x\s*/g, '$1 x ')
        .replace(/\s+/g, ' ').trim();
    }
    function normTitle(t) { return normalize(t || ''); }
    function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

    function render(items, term) {
      lastShown = items || [];
      var html = '';
      if (!items.length) {
        html = '<div class="es-search-results__empty">No matches for "' + esc(term) + '"</div>';
      } else {
        items.forEach(function (p) {
          html += '<a class="es-sresult" href="' + p.url + '">' +
            '<span class="es-sresult__img">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="es-sresult__name">' + esc(p.title) + '</span></a>';
        });
      }
      html += '<a class="es-search-results__all" href="/search?q=' + encodeURIComponent(term) + '&type=product">See all results &rarr;</a>';
      results.innerHTML = html;
      results.hidden = false;
    }

    function parseQ(qnorm) {
      var dimM = qnorm.match(/\d+(?:\.\d+)?\s*x\s*\d+(?:\.\d+)?(?:\s*x\s*\d+(?:\.\d+)?)?/);
      var milM = qnorm.match(/\d+(?:\.\d+)?\s*mil/);
      var dim = dimM ? dimM[0] : '';
      var dimRe = null;
      if (dim) {
        var e = dim.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        dimRe = new RegExp('(^|[^0-9.])' + e + '([^0-9.]|$)');   // standalone size, not part of a bigger number
      }
      return { tokens: qnorm.split(' ').filter(Boolean), dim: dim, dimRe: dimRe, mil: milM ? milM[0] : '', flat: qnorm.replace(/\s/g, '') };
    }

    function searchIndex(qnorm) {
      var p = parseQ(qnorm);
      var scored = [];
      for (var k = 0; k < index.length; k++) {
        var it = index[k];
        var t = normTitle((it.t || '') + ' ' + (it.g || ''));
        var s = 0;
        if (it.s) for (var j = 0; j < it.s.length; j++) {
          var sku = (it.s[j] || '').toLowerCase();
          if (sku && (sku === p.flat || sku.indexOf(p.flat) !== -1)) s += 50;
        }
        for (var n = 0; n < p.tokens.length; n++) { if (t.indexOf(p.tokens[n]) !== -1) s += 1; }
        if (p.dimRe && p.dimRe.test(t)) s += 30;   // exact standalone dimension (e.g. 2 x 2, not inside 12 x 24)
        if (p.mil && t.indexOf(p.mil) !== -1) s += 10;
        if (s > 0) scored.push({ it: it, s: s, i: k });
      }
      scored.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
      return scored.slice(0, ES_SEARCH_LIMIT).map(function (o) {
        return { title: o.it.t, url: o.it.u, image: o.it.i };
      });
    }

    function buildIndex() {
      if (index || indexLoading) return;
      indexLoading = true;
      fetch('/collections/search-feed?view=feed&page=1')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = d.items || [];
          var pages = d.pages || 1;
          var more = [];
          for (var pg = 2; pg <= pages; pg++) {
            more.push(fetch('/collections/search-feed?view=feed&page=' + pg).then(function (r) { return r.json(); }).then(function (d2) { return d2.items || []; }));
          }
          Promise.all(more).then(function (rest) {
            rest.forEach(function (arr) { items = items.concat(arr); });
            index = items;
            indexLoading = false;
            if (input.value.trim().length >= 2) run();
          });
        })
        .catch(function () { indexLoading = false; });
    }

    function fallback(qnorm, raw) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(qnorm) +
        '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,variants.sku';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
          var mapped = prods.map(function (pp) { return { t: pp.title, u: pp.url, i: (pp.featured_image && pp.featured_image.url) || pp.image || '', s: [] }; });
          var saved = index; index = mapped;
          var out = searchIndex(qnorm); index = saved;
          render(out, raw);
        })
        .catch(function () { results.hidden = true; });
    }

    function run() {
      var raw = input.value.trim();
      if (raw.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      var q = normalize(raw);
      if (index && index.length) {
        var out = searchIndex(q);
        if (out.length) render(out, raw);
        else fallback(q, raw);
      } else {
        buildIndex();
        fallback(q, raw);
      }
    }

    if (form) on(form, 'submit', function (e) {
      if (lastShown.length === 1 && lastShown[0].url) { e.preventDefault(); window.location.href = lastShown[0].url; }
    });
    on(input, 'input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
    on(input, 'focus', function () { buildIndex(); if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false; });
    on(document, 'click', function (e) { if (!wrap.contains(e.target)) results.hidden = true; });
    on(input, 'keydown', function (e) { if (e.key === 'Escape') results.hidden = true; });
  }

  /* ===================== Read-more (collapsible content) ===================== */
  function bindReadmore() {
    $all('[data-readmore]').forEach(function (w) {
      var content = w.querySelector('.es-readmore__content');
      var btn = w.querySelector('[data-readmore-toggle]');
      if (!content || !btn) return;
      if (content.scrollHeight <= 340) return; // short enough, leave fully shown
      w.classList.add('es-readmore--on');
      btn.hidden = false;
      on(btn, 'click', function () {
        var open = w.classList.toggle('is-open');
        btn.textContent = open ? 'View less' : 'View more';
      });
    });
  }

  /* ===================== Mobile PDP gallery swipe ===================== */
  function bindGallery() {
    var g = $('[data-gallery-track]');
    if (!g) return;
    var counter = $('[data-gallery-counter]');
    var slides = $all('[data-gallery-slide]', g);
    function update() {
      var idx = Math.round(g.scrollLeft / g.clientWidth);
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    }
    on(g, 'scroll', update);
    update();
    // thumbnail clicks (desktop)
    $all('[data-thumb]').forEach(function (t) {
      on(t, 'click', function () {
        var main = $('[data-gallery-main]');
        var mainImg = main && main.querySelector('img');
        var full = t.getAttribute('data-full') || (t.querySelector('img') && t.querySelector('img').getAttribute('src'));
        if (full) setImgSrc(mainImg, full);
        $all('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        // If this image belongs to a color/variant, select that variant so the
        // Color dropdown, price, SKU and price breaks update to match the photo.
        var imageId = t.getAttribute('data-image-id');
        if (imageId) {
          var root = t.closest('[data-pdp]') || document;
          var vsel = root.querySelector('[data-variant-select]');
          if (vsel) {
            var match = vsel.querySelector('option[data-image-id="' + imageId + '"]');
            if (match && vsel.value !== match.value) {
              vsel.value = match.value;
              vsel.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });
    });
  }

  /* ===================== Tabs ===================== */
  function bindTabs() {
    $all('[data-tabs]').forEach(function (group) {
      var tabs = $all('[data-tab]', group);
      var panels = $all('[data-tab-panel]', group);
      tabs.forEach(function (tab) {
        on(tab, 'click', function () {
          var k = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { p.style.display = p.getAttribute('data-tab-panel') === k ? 'block' : 'none'; });
        });
      });
    });
  }

  /* ===================== Payment / delivery segmented selectors ===================== */
  function bindSegments() {
    $all('[data-segment]').forEach(function (group) {
      var opts = $all('[data-seg-opt]', group);
      var input = group.querySelector('[data-seg-input]');
      opts.forEach(function (o) {
        on(o, 'click', function () {
          opts.forEach(function (x) { x.classList.toggle('is-active', x === o); });
          if (input) input.value = o.getAttribute('data-seg-opt');
          var target = o.getAttribute('data-seg-reveal');
          if (target) {
            $all('[data-seg-panel]', group).forEach(function (p) {
              p.style.display = p.getAttribute('data-seg-panel') === target ? 'block' : 'none';
            });
          }
        });
      });
    });
  }

  /* ===================== Hero carousel ===================== */
  function bindHeroCarousel() {
    var root = $('[data-hero-carousel]');
    if (!root) return;
    var track = root.querySelector('[data-hero-track]');
    if (!track) return;
    var slides = $all('.es-hero__slide', track);
    if (slides.length < 2) return;
    var dots = $all('[data-hero-dot]', root);
    var i = 0, timer = null;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }

    var autoplay = parseInt(root.getAttribute('data-hero-autoplay'), 10);
    // Respect reduced-motion preferences: no auto-advance.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) autoplay = 0;
    function start() { if (autoplay && !timer) timer = setInterval(next, autoplay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    on(root.querySelector('[data-hero-next]'), 'click', function () { next(); stop(); start(); });
    on(root.querySelector('[data-hero-prev]'), 'click', function () { prev(); stop(); start(); });
    dots.forEach(function (d) { on(d, 'click', function () { go(parseInt(d.getAttribute('data-hero-dot'), 10)); stop(); start(); }); });
    on(root, 'mouseenter', stop);
    on(root, 'mouseleave', start);
    on(root, 'focusin', stop);
    on(root, 'focusout', start);

    // touch swipe
    var x0 = null;
    on(track, 'touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    on(track, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (dx < -40) next(); else if (dx > 40) prev();
      x0 = null; start();
    });

    go(0); start();
  }

  function bindAll() {
    bindHeroCarousel();
    bindSteppers();
    bindPDP();
    bindCardVariants();
    bindStockTable();
    bindStockWholesale();
    bindOrdering();
    bindFilterToggle();
    bindReadmore();
    bindPredictiveSearch();
    bindGallery();
    bindTabs();
    bindSegments();
    bindStepperChanges();
    updateFreightBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  ES.bindAll = bindAll;
  window.ES = ES;
})();
